import { Component, EventEmitter, Input, OnDestroy, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Subject } from 'rxjs';
import Swal from 'sweetalert2';

import { PersistenceApiService } from '../../../../shared/services/persistence-api.service';
import { HighlightInfo } from '../document-highlighter/document-highlighter.component';
import { PersistedFileInfo } from '../knowledge-base.component';

@Component({
  selector: 'app-file-content-viewer',
  templateUrl: './file-content-viewer.component.html',
  styleUrls: ['./file-content-viewer.component.scss']
})
export class FileContentViewerComponent implements OnDestroy {
  @Input() fileInfo!: PersistedFileInfo;
  @Input() currentUserEmail!: string;
  @Input() projectId!: string;
  @Input() selectedModel!: string;
  @Output() indexRequested = new EventEmitter<void>();

  // Highlights set externally (e.g. from agent source traceability)
  mappedSnippetsForHighlighter: HighlightInfo[] = [];

  private destroy$ = new Subject<void>();

  constructor(
    public activeModal: NgbActiveModal,
    private persistenceApiService: PersistenceApiService
  ) {}

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  indexDocument(): void {
    if (!this.fileInfo?.id) return;

    Swal.fire({
      title: 'Index Document?',
      text: 'This will process in the background. You can close this window.',
      icon: 'info',
      showCancelButton: true,
      confirmButtonText: 'Start Indexing',
      confirmButtonColor: '#198754'
    }).then((result) => {
      if (result.isConfirmed) {
        this.indexRequested.emit();
      }
    });
  }
}
